import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';
export default {
  setTransition,
  transitionStart,
  transitionEnd
};


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/myboo.dev.booom.digital/httpdocs/wp-content/themes/booom/node_modules/swiper/core/transition/index.js
// module id = 48
// module chunks = 0